/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ApiConfig} from "../../api";
import {Injectable} from '@angular/core';

import * as _ from 'lodash';
import {AdnHttpService} from '../../../util/adn-http.service';
import {AdnHttpSender, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';



@Injectable()
export class ReachEstimateResource {
  private readonly uriDiag: string = ApiConfig.obtain().getVersionedUri(['reachestimate', 'diag']);
  private readonly send: AdnHttpSender;

  constructor(
    AdnHttp: AdnHttpService,
    authHttpInterceptor: AuthHttpInterceptorService,
    ApiErrorHandler: ApiErrorHandlerService
  ) {
    this.send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  }

  save(lineItemId, data, params, cb, errCb) {
    const versioned = ['reachestimate'];
    if (lineItemId) {
      versioned.push(lineItemId);
    }
    const uri = ApiConfig.obtain().getVersionedUri(versioned);
    return this.send({method: 'POST', url: uri, params: params || {}, body: data}).then(function(response) {
      return (cb || _.noop)(response);
    }).catch(function(response) {
      return (errCb || _.noop)(response);
    });
  }

  diag(cb, errCb) {
    return this.send({method: 'GET', url: this.uriDiag}).then(function(response) {
      return (cb || _.noop)(response);
    }).catch(function(response) {
      return (errCb || _.noop)(response);
    });
  }
}
